<!--
 * @Author: your name
 * @Date: 2020-11-20 09:41:47
 * @LastEditTime: 2021-01-05 15:17:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/SignUpPage/index.vue
-->
<style lang="sass" scoped>
.sign_up_page
  display: flex
  flex-direction: column

.title
  display: flex
  align-items: center
  justify-content: center
  height: 64PX
  font-size: 17PX

.sign_up
  height: 56PX
  font-size: 15PX
  color: #fff

.close_box
  flex: 1
  display: flex
  align-items: center
  justify-content: center
  height: 13PX
  margin-top: 20PX
  margin-bottom: 5PX
  text-decoration: underline

.close
  padding: 10PX
  line-height: 13PX
  font-size: 13PX

.custom_title
  text-align: center
  line-height: 18px
  font-size: 14px
  color: var(--menu-primary-text-colour)
  margin: 20px 0 15px
</style>

<template lang="pug">
.sign_up_page
  //- .title.b(v-if="!$attrs['marketing-consent-message']") {{ defaultMarketingContentMessage}}
  .custom_title.o75 {{ $attrs['marketing-consent-message'] || defaultMarketingContentMessage}}
  van-button.sign_up.b(type="primary" size="large" @click="signUp") {{ t('sign_up', 'SIGN UP') }}
  .close_box
    span.close.o6(@click="closeDialog") {{ t('no_thanks', 'No thanks') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'

@Component
class SignUpPage extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  defaultMarketingContentMessage = t('join_mailing_list', 'Would you like to join our mailing list?')

  closeDialog() {
    this.$emit('closeDialog')
  }

  signUp() {
    this.$emit('signUp')
  }
}

export default SignUpPage
</script>
